import $ from 'gridstrap/lib/gs-zepto';

export class GSHorizontalScroller {

	private root;
	private content;
	private leftButton;
	private rightButton;

	get scrollPos() { return this.content.get(0).scrollLeft; }
	set scrollPos(value) { this.content.get(0).scrollTo(value, 0); }

	set hasLeftOverflow(value) { this.root.toggleClass('has-left-overflow', !!value); }
	set hasRightOverflow(value) { this.root.toggleClass('has-right-overflow', !!value); }

	check() {
		let container = this.content.width();
		let content = this.content.get(0).scrollWidth;
		this.hasLeftOverflow = (this.content.scrollLeft() > 5);
		this.hasRightOverflow = (this.content.scrollLeft() < content - container - 5);
	}

	scrollLeft() {
		let item = this.content.children().first().width();
		let max = this.content.get(0).scrollWidth - this.content.width();
		let pos = this.scrollPos - item;
		if (max - this.scrollPos < 10) pos += this.content.width() % item;

		this.scrollTo(pos, 500);
		this.hasRightOverflow = true;
		setTimeout(() => this.hasLeftOverflow = pos > 5, 300);
	}

	scrollRight() {
		let item = this.content.children().first().width();
		let pos = this.scrollPos + item;
		let max = this.content.get(0).scrollWidth - this.content.width();

		this.scrollTo(Math.min(pos, max), 500);
		this.hasLeftOverflow = true;
		setTimeout(() => this.hasRightOverflow = pos < max - 5, 300);
	}

	scrollTo(pos, duration) {
		let initial = this.content.scrollLeft();
		let dest = pos - initial;
		let start;

		let step = (ts) => {
			if (!start) start = ts;
			let prog = ts - start;
			let perc = prog / duration;
			let tick = (easeInOutQuart(perc) * dest) + initial;
			this.content.scrollLeft(tick);

			if (prog < duration) {
				window.requestAnimationFrame(step);
			} else {
				$(window).trigger('resize');
				return;
			}
		}

		window.requestAnimationFrame(step);
	}

	constructor(root) {
		this.root = $(root);
		this.content = this.root.find('.gs-HorizontalScroller-content');
		this.leftButton = this.root.find('.gs-HorizontalScroller-scrollButton--left');
		this.rightButton = this.root.find('.gs-HorizontalScroller-scrollButton--right');
	}

	gsOnInit() {
		this.leftButton.on('click', () => this.scrollLeft());
		this.rightButton.on('click', () => this.scrollRight());
	}

	gsOnWindowResize() {
		this.check();
	}

}

function easeInOutQuart(t) {
  const t1 = t - 1
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * t1 * t1 * t1 * t1
}
